<template>
    <div v-show="show" ref="mediaPlayer" class="mediaPlayer" :style="soundManagerStyle">
        <div ref="hitArea" class="hit-area"></div>
        <div v-show="showSetting" class="setting-field" :class="{ 'simple': store.playerType == PLAYER_TYPE.SIMPLE }">
            <div v-show="store.playerType == PLAYER_TYPE.FULL">
                <br><br>
                <span>朗讀次數：</span>
                <select class="select-field" name="speekeSelect" v-model="selectObj.speakCountVal"
                    @change="speekeOnChange">
                    <option v-for="item in speakArr" :key="item.id" :value="item.value">
                        {{ item.text }}
                    </option>
                </select>
                <br>
            </div>
            <div v-show="store.playerType == PLAYER_TYPE.FULL">
                <span>語句間隔：</span>
                <select class="select-field" name="sentenceSelect" v-model="selectObj.sentenceBlankVal"
                    @change="sentenceOnChange">
                    <option v-for="item in sentenceArr" :key="item.id" :value="item.value">
                        {{ item.text }}
                    </option>
                </select>
                <br>
            </div>
            <div>
                <span>播放速度：</span>
                <select class="select-field" name="speedSelect" v-model="selectObj.speedVal" @change="speedOnChange">
                    <option v-for="item in speedArr" :key="item.id" :value="item.value">
                        {{ item.text }}
                    </option>
                </select>
                <br>
                <button @click="confirmHandler">確定</button>
                <button @click="cancelHandler">取消</button>
                <button @click="defaultHandler">預設值</button>
            </div>
        </div>
        <div class="tool-field">
            <img id="mediaMoveBg" @pointerdown="startDrag($event, $refs.hitArea, soundManagerDragMargin)"
                :src="moveIcon" draggable="false">
            <img v-show="isPlay" class="play-button" :src="playIcon" @click="playHandler">
            <img v-show="!isPlay" class="pause-button" :src="pauseIcon" @click="pauseHandler">
            <img class="stop-button" :src="stopIcon" @click="stopHandler">
            <input type="range" ref="seekBar" class="seek-bar"  @change="rangeOnChange($refs.seekBar)" @pointerdown="onPointerDown" @input="onDragSeekBar($refs.seekBar)">
            <img class="volume-button" v-show="volume > 0" :src="volumeIcon" @click="volumeButtonHandler">
            <img class="volume-button" v-show="volume == 0" :src="volume0Icon" @click="volumeButtonHandler">
            <div class="volume-block" v-show="showVolume">
                <input type="range" ref="volumeBar" v-model="currentVolume" :min="minVolume" :max="maxVolume"
                    :style="{ 'background-size': volumeStr + '% 100%' }" step="0.01" @input="onChangeVolume" />
                <span>{{ volumeStr }}</span>
            </div>
            <img class="setting-button" :src="settingIcon" @click="settingButtonHandler">
            <img id="mediaCloseBtn" @click="close()" :src="closeIcon" draggable="false">
            <br>
            <span class="current-time">{{ currentShowTime }} / {{ totalTime }}</span>
        </div>
        <audio ref="soundPlayer" class="soundPlayer" controlslist="nodownload" draggable="false" hidden>
            <source id="sourceScr" type="audio/mpeg" :src="musicPath">
        </audio>
    </div>
</template>

<script>
import BookData from '../js/book_data';
import DragElemVue from './DragElem.vue';
import { PLAYER_TYPE } from '../js/bookItems/sound/player_type';
import AudioEvent from '../js/event/audio_event';
import { windowContentScaleY } from '../js/common/content_scale';
import { useStore } from '@/stores/media.js';
import { store } from '@/store.js';

export default {
    name: 'sound_manager',
    data: function () {
        return {
            show: false,
            isPlay: true,
            showSetting: false,
            showVolume: false,
            mediaPlayer: null,
            soundPlayer: null,

            moveIcon: require("@/assets/media/drag.svg"),
            playIcon: require("@/assets/media/play.svg"),
            pauseIcon: require("@/assets/media/pause.svg"),
            stopIcon: require("@/assets/media/stop.svg"),
            volumeIcon: require("@/assets/media/sound.svg"),
            volume0Icon: require("@/assets/player/sound0.svg"),
            settingIcon: require("@/assets/media/setting.svg"),
            closeIcon: require("@/assets/media/close.svg"),
            musicPath: "",

            callBackFuncs: [],
            isPlaying: false,   //暫時無用(需排查)

            //移動用
            isDrag: false,
            top: 0,
            left: 0,
            //重置位置用
            origPos: {
                top: 0,
                left: 0
            },
            speedArr: [
                { id: 1, value: 0.5, text: "0.5倍" },
                { id: 2, value: 0.75, text: "0.75倍" },
                { id: 3, value: 1, text: "正常" },
                { id: 4, value: 1.25, text: "1.25倍" },
                { id: 5, value: 1.5, text: "1.5倍" }
            ],
            sentenceArr: [
                { id: 0, value: 0, text: "0秒" },
                { id: 1, value: 1, text: "1秒" },
                { id: 2, value: 2, text: "2秒" },
                { id: 3, value: 3, text: "3秒" },
                { id: 4, value: 4, text: "4秒" },
                { id: 5, value: 5, text: "5秒" }
            ],
            speakArr: [
                { id: 1, value: 1, text: "1次" },
                { id: 2, value: 2, text: "2次" },
                { id: 3, value: 3, text: "3次" }
            ],
            selectObj: {
                speakCountVal: 1,
                sentenceBlankVal: 0,
                speedVal: 1
            },
            currentTime: "00:00",
            tempCurrentTime: "00:00",
            totalTime: "00:00",
            rangeVal: 0,
            durationTime: 0,
            defaultAudioConfig: {
                timeSteps: [],
            },

            speakCount: 1,
            minVolume: 0,
            maxVolume: 1,
            volume: 50,
            currentVolume: 0.5,
            volumeStr: '50',
            originWidth: 1920,
            originHeight: 1017,
            store,
            PLAYER_TYPE,

            audioPlayerStopHandler: null,
            timeupdateInterval: 0,

            isEnd: false,
            currentPlayPage: "",
        };
    },
    mixins: [
        DragElemVue
    ],
    props: {
        audioConfig: Object
    },
    created() {
        const vm = this;
        const STORE = useStore();
        vm.selectObj.speakCountVal = STORE.speakCountVal;
        vm.selectObj.sentenceBlankVal = STORE.sentenceBlankVal;
        vm.selectObj.speedVal = STORE.speedVal;
        console.log(STORE);
    },
    mounted() {
        const vm = this;
        const STORE = useStore();

        STORE.speedVal = 1;

        //註冊全域播放管理
        window.soundManager = this;
        //設定播放器介面
        vm.mediaPlayer = vm.$refs.mediaPlayer;
        //設定播放器
        vm.soundPlayer = vm.$refs.soundPlayer;
        //設定播放速度
        vm.soundPlayer.playbackRate = STORE.speedVal;

        console.log("play speed:", vm.soundPlayer.playbackRate);

        //設定總音檔時間
        vm.soundPlayer.onloadedmetadata = () => {
            vm.durationTime = vm.soundPlayer.duration;
            if (vm.durationTime > 1) {
                vm.totalTime = new Date(vm.durationTime * 1000).toISOString().substring(14, 19);
            } else {
                vm.totalTime = "00:00";
            }
        };
        vm.audioPlayerStopHandler = vm.audioPlayerStop.bind(this);
        //vm.soundPlayer.addEventListener("ended", vm.audioPlayerStopHandler);

        // progress bar event
        let mousedown = false;
        // vm.$refs.seekBar.addEventListener('mousedown', () => {
        //     mousedown = true;
        //     vm.$refs.seekBar.addEventListener('mousemove', (e) => mousedown && vm.scrub(e));
        // });
        vm.$refs.seekBar.addEventListener('mouseup', () => mousedown = false);

        //設定初始位置
        vm.resetPlayerPosition();

    },
    methods: {
        audioPlayerPlay(src, callBackFunc, playPage) {
            const vm = this;
            const STORE = useStore();
            vm.audioPlayerStop();
            vm.callBackFuncs.push(callBackFunc);
            vm.soundPlayer.src = BookData.Instance.getBookContentPath() + src;
            vm.soundPlayer.play();
            vm.isPlaying = true;
            vm.isPlay = false;
            vm.speakCount = 1;

            vm.origPos.left = 0;
            vm.origPos.top = 0;

            vm.showSetting = false;
            vm.showVolume = false;
            vm.isEnd = false;
            this.clearTimeUpdate();
            this.startTimeUpdate();

            //設定播放速度
            vm.soundPlayer.playbackRate = STORE.speedVal;
            this.selectObj.speedVal = STORE.speedVal;

            this.currentPlayPage = playPage;
        },
        audioPlayerStop(closeUI = true) {
            const vm = this;
            if (vm.callBackFuncs != []) {
                let temp = vm.callBackFuncs;
                vm.callBackFuncs = [];
                for (let i = 0; i < temp.length; i++) {
                    temp[i]();
                }
            }

            AudioEvent.Instance.clearPlayingCallBacks();
            AudioEvent.Instance.doPlayEndCallback();

            vm.stopHandler();
            vm.isPlaying = false;
            if (closeUI) vm.switchMediaDisplay(false);
        },
        switchMediaDisplay(bool) {
            const vm = this;
            //若重開則重置位置
            if (!vm.show && bool) {
                vm.resetPlayerPosition();
            }

            vm.show = bool;
        },
        setCallBackFunc(func) {
            const vm = this;
            vm.callBackFuncs.push(func);
        },
        settingRepeat(timeSec) {
            const vm = this;

            let isRepeat = false;

            if (vm.audioConfig.timeSteps == undefined) {
                return false;
            }
            let firstTime = vm.audioConfig.timeSteps[0];
            let secondTime = vm.audioConfig.timeSteps[1] || vm.durationTime;
            if (timeSec >= secondTime) {
                // console.log(`${vm.selectObj.speakCountVal} > ${vm.speakCount}`);
                if (vm.selectObj.speakCountVal > vm.speakCount) {
                    vm.sentencePause(firstTime);
                    vm.speakCount = vm.speakCount + 1;
                    isRepeat = true;
                } else {
                    vm.sentencePause();
                    console.log("no need repeat");
                    vm.speakCount = 1;
                    let arr = vm.audioConfig.timeSteps.slice(2);
                    vm.audioConfig.timeSteps = arr;
                    isRepeat = false;

                    if (vm.audioConfig.timeSteps.length <= 0) {
                        if(secondTime >= vm.durationTime) {
                            this.isEnd = true;
                        }
                    }
                }
            }

            return isRepeat;

        },
        sentencePause(firstTime = null) {
            const vm = this;
            if (vm.selectObj.sentenceBlankVal > 0 || vm.selectObj.speakCountVal > 1) {
                console.log("repeat");
                vm.pauseHandler();
                vm.soundPlayer.currentTime = firstTime == null ? vm.soundPlayer.currentTime : firstTime;
                setTimeout(() => {
                    if (!this.isEnd) {
                        vm.playHandler();
                    }
                }, vm.selectObj.sentenceBlankVal * 1000);
            }
        },
        resetPlayerPosition() {
            const vm = this;
            vm.top = vm.origPos.top;
            vm.left = vm.origPos.left;
        },
        playHandler() {
            const vm = this;
            vm.isPlay = false;
            vm.isEnd = false;
            vm.soundPlayer.play();
        },
        pauseHandler() {
            const vm = this;
            vm.isPlay = true;
            vm.soundPlayer.pause();
        },
        stopHandler() {
            const vm = this;
            vm.isPlay = true;
            vm.soundPlayer.currentTime = 0;
            vm.soundPlayer.pause();
        },
        rangeOnChange(seekBar) {
            const vm = this;

            console.log("rangeVal::", seekBar.value);

            let progressBarVal = seekBar.value;
            vm.soundPlayer.currentTime = progressBarVal * vm.durationTime / 100;
            // reset speakCount when user seek time
            vm.speakCount = 1;

            let first;

            // 篩選出 currentTime 之後的播放時間
            let filterArr = vm.defaultAudioConfig.timeSteps.filter((item, index) => {
                if (first == null) {
                    if (vm.soundPlayer.currentTime <= item) {
                        first = index;
                    }
                }
                return vm.soundPlayer.currentTime <= item;
            });


            // 取得完整的偶數陣列
            if ((filterArr.length & 1) !== 0) {
                // filterArr.shift()
                filterArr.splice(0, 0, vm.defaultAudioConfig.timeSteps[first - 1]);
            }

            vm.audioConfig.timeSteps = filterArr;
        },
        scrub(e) {
            const vm = this;
            console.log(e);
            const scrubTime = (e.offsetX / vm.$refs.seekBar.offsetWidth) * vm.durationTime;
            vm.soundPlayer.currentTime = scrubTime;
        },
        onChangeVolume(val) {
            const vm = this;
            vm.volumeStr = parseInt(val.target.valueAsNumber * 100);
            vm.soundPlayer.volume = val.target.valueAsNumber;
            vm.volume = val.target.valueAsNumber;
        },
        volumeButtonHandler() {
            const vm = this;
            vm.showVolume = !vm.showVolume;
        },
        settingButtonHandler() {
            const vm = this;
            vm.showSetting = !vm.showSetting;
        },
        speekeOnChange(val) {
            const vm = this;
            vm.selectObj.speakCountVal = val.target.value * 1;
        },
        sentenceOnChange(val) {
            const vm = this;
            vm.selectObj.sentenceBlankVal = val.target.value * 1;
        },
        speedOnChange(val) {
            const vm = this;
            vm.selectObj.speedVal = val.target.value * 1;
        },
        confirmHandler() {
            const vm = this;
            const STORE = useStore();

            STORE.$patch((state) => {
                state.speakCountVal = vm.selectObj.speakCountVal;
                state.sentenceBlankVal = vm.selectObj.sentenceBlankVal;
                state.speedVal = vm.selectObj.speedVal;
            });

            vm.soundPlayer.playbackRate = STORE.speedVal;
            vm.showSetting = false;
            vm.speakCount = 1;
            vm.audioConfig.timeSteps = vm.defaultAudioConfig.timeSteps;
            vm.stopHandler();
        },
        cancelHandler() {
            const vm = this;
            vm.showSetting = false;
        },
        defaultHandler() {
            const vm = this;
            const OBJ = {
                speakCountVal: 1,
                sentenceBlankVal: 0,
                speedVal: 1
            };

            const STORE = useStore();

            STORE.$patch((state) => {
                state.speakCountVal = OBJ.speakCountVal;
                state.sentenceBlankVal = OBJ.sentenceBlankVal;
                state.speedVal = OBJ.speedVal;
            });

            vm.selectObj = OBJ;
            vm.speakCount = 1;
            vm.stopHandler();
        },
        timeUpdateHandler() {
            let currentSecTime = this.soundPlayer.currentTime;
            this.rangeVal = currentSecTime / this.durationTime * 100;
            this.$refs.seekBar.value = this.rangeVal;
            this.currentTime = new Date(currentSecTime * 1000).toISOString().substring(14, 19);

            AudioEvent.Instance.doPlayingCallbacks();

            if (this.rangeVal >= 100 && store.playerType == PLAYER_TYPE.SIMPLE) {
                this.isEnd = true;
            }

            if (!this.isEnd && store.playerType == PLAYER_TYPE.FULL) {
                this.settingRepeat(currentSecTime);
            }

            if (this.rangeVal >= 100) {
                this.stopHandler();
            }
        },
        seekEndHandler() {
            window.removeEventListener("pointerup", this.seekEndHandler);
            this.speakCount = 1;

            this.rangeOnChange(this.$refs.seekBar);


            this.playHandler();
            this.startTimeUpdate();
        },
        setDefaultAudioConfig(timeSteps) {
            this.defaultAudioConfig.timeSteps = timeSteps;
        },
        onPointerDown(e) {
            console.log(e);
            this.clearTimeUpdate();
            this.soundPlayer.pause();
            this.isPlay = true;

            window.addEventListener("pointerup", this.seekEndHandler);
        },
        onDragSeekBar(seekBar) {
            const value = seekBar.value;
            const currentSecond = value * this.durationTime / 100;
            this.tempCurrentTime = new Date(currentSecond * 1000).toISOString().substring(14, 19);
            console.log("range value:", this.tempCurrentTime);
        },
        close() {
            this.isEnd = true;
        },
        startTimeUpdate() {
            this.timeupdateInterval = setInterval(this.timeUpdateHandler, 16);
        },
        clearTimeUpdate() {
            clearInterval(this.timeupdateInterval);
        }
    },
    computed: {
        windowScaleHandle() {
            const vm = this;
            document.documentElement.style.setProperty('--window-devicePixelRatio', window.devicePixelRatio);
            vm.origPos.top = store.contentSize.height * 0.5 / windowContentScaleY.value;
            vm.origPos.left = (store.baseSize.width - 662) * 0.5;

            this.resetPlayerPosition();
            return true;
        },
        soundManagerStyle() {
            return {
                "top": this.top + "px",
                "left": this.left + "px",
                'RWD': this.windowScaleHandle
            };
        },
        soundManagerDragMargin() {
            let marginTop;
            if (this.showSetting) {
                if (store.playerType == PLAYER_TYPE.SIMPLE) {
                    marginTop = 160;
                } else {
                    marginTop = 0;
                }
            } else {
                marginTop = 336;
            }
            return {
                top: marginTop,
                right: 0,
                bottom: 0,
                left: 0
            };
        },
        currentShowTime() {
            if(this.isPlay == false) {
                return this.currentTime;
            }else {
                return this.tempCurrentTime;
            }
        }
    },
    watch: {
        "showSetting": {
            handler: function (newValue, oldValue) {
                const marginTop = store.playerType == PLAYER_TYPE.SIMPLE ? 160 : 0;
                if (newValue == true) {
                    if (this.top < 0 - marginTop) {
                        this.top = 0 - marginTop;
                    }
                }
            }
        },
        "show": {
            handler: function (newValue, oldValue) {
                if (newValue == false) {
                    this.clearTimeUpdate();  
                }
            }
        },
        "isEnd": {
            handler: function (newValue) {
                if(newValue == true) {
                    this.audioPlayerStopHandler();
                    this.defaultAudioConfig.timeSteps = [];
                }
            }
        }
    }
};
</script>

<style lang="css" scoped>
.setting-field {
    position: absolute;
    background: #FFFFFF;
    margin: auto;
    width: 650px;
    height: 400px;
    border: 1px;
    border-style: solid;
    border-width: 6px;
    border-color: #272727;
    border-radius: 30px;
    z-index: 5;
}

.setting-field.simple {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 200px;
    top: 160px;

}

.setting-field span {
    font-size: 30px;
    display: flex;
    margin-left: 110px;
    font-weight: bold;
}

.setting-field button {
    position: relative;
    background-color: #03B5A4;
    color: #fff;
    width: 150px;
    height: 50px;
    border: 0;
    border-radius: 50px;
    font-size: 24px;
    margin-right: 20px;
    margin-left: 20px;
    bottom: 22px;
    cursor: pointer;
}

.setting-field button:hover {
    background-color: #fff;
    color: #003c9d;
    border: 2px #003c9d solid;
}

.select-field {
    position: relative;
    width: 160px;
    height: 40px;
    bottom: 40px;
    left: 66px;
    font-size: 24px;
    border: 1px solid #272727;
    border-radius: 10px;
    cursor: pointer;
}

.mediaPlayer {
    position: absolute;
    top: 80%;
    z-index: var(--z-index-sound-manager);
}

.mediaPlayer img {
    margin-right: 10px;
    cursor: pointer;
}

.mediaPlayer .volume-block {
    position: absolute;
    background-color: #FFFFFF;
    border: 2px solid #FFFFFF;
    width: 40px;
    z-index: 10;
    right: 155px;
    top: -130px;
}

.mediaPlayer .volume-block input {
    position: relative;
    appearance: slider-vertical;
    right: 45px;
}

.tool-field {
    position: absolute;
    margin-top: 336px;
    width: 662px;
    left: 0px;
    border-radius: 10px;
    background: #272727;
    z-index: 6;
}

/* .tool-field img:hover {
    position: relative;
    left: 1px;
} */

.tool-field #mediaMoveBg {
    position: relative;
    top: 10px;
    width: 50px;
}

.tool-field #mediaCloseBtn {
    position: relative;
    top: 10px;
    width: 50px;
}

.tool-field .play-button {
    position: relative;
    top: 10px;
    width: 50px;
}

.tool-field .pause-button {
    position: relative;
    top: 10px;
    width: 50px;
}

.tool-field .stop-button {
    position: relative;
    top: 10px;
    width: 50px;
}

.tool-field .volume-button {
    position: relative;
    top: 10px;
    width: 50px;
}

.tool-field .setting-button {
    position: relative;
    top: 10px;
    width: 50px;
}

.tool-field .current-time {
    position: relative;
    font-size: 20px;
    bottom: 5px;
    color: #fff;
}

.tool-field .volume-block {
    position: absolute;
    background-color: #FFFFFF;
    border: 2px solid #FFFFFF;
    width: 40px;
    z-index: 10;
    right: 220px;
    top: -170px;
}

.tool-field .volume-block span {
    font-size: 20px;
}

.tool-field .volume-block input {
    position: relative;
    top: 60px;
    right: 45px;
    margin-bottom: 120px;
    outline: none;
    cursor: pointer;
    -webkit-appearance: none;
    border-radius: 10px;
    background-color: #9D9D9D;
    background-size: 50% 100%;
    background-image: linear-gradient(#46A3FF, #46A3FF);
    background-repeat: no-repeat;
    transform: rotate(-90deg);
}

.tool-field .volume-block input::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 1.5em;
    height: 1.5em;
    border-radius: 100%;
    background-color: #FFFFFF !important;
    box-shadow: 0px 0px 20px #272727;

}

.tool-field .volume-block .seek-bar {
    -webkit-appearance: none;
    position: relative;
    background: #9D9D9D;
    width: 250px;
    height: 20px;
    border-radius: 10px;
    overflow: hidden;
    bottom: 10px;
    margin-right: 10px;
    cursor: pointer;
    outline: none;
}

.tool-field .volume-block .seek-bar::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 1.5em;
    height: 1.5em;
    border-radius: 100%;
    background-color: #FFFFFF;
    box-shadow: -400px 0 0 400px #46A3FF;
}

.hit-area {
    position: fixed;
    width: 662px;
    height: 412px;
    pointer-events: none;
}
</style>